import request from '@/request/request'
let baseURL = global.$config.api.apiUrl + '/emergency-server/'
// 应急物资列表-分页
export function materialList(query) {
  return request({
    baseURL,
    url: '/emergencyMaterial/list',
    method: 'get',
    params: query
  })
}
// 应急物资新增
export function materialSave(data) {
  return request({
    baseURL,
    url: '/emergencyMaterial/save',
    method: 'post',
    data
  })
}
// 应急物资修改
export function materialUpdate(data) {
  return request({
    baseURL,
    url: '/emergencyMaterial/update',
    method: 'post',
    data: data
  })
}
// 应急物资-详情
export function materialDetail(id) {
  return request({
    baseURL,
    url: '/emergencyMaterial/detail?id=' + id,
    method: 'get'
  })
}
// 应急物资-删除
export function materialRemove(data) {
  return request({
    baseURL,
    url: '/emergencyMaterial/remove',
    method: 'post',
    data: { ...data, isFormData:true }
  })
}